import { useSyncExternalStore } from "react";
import { getState, subscribe, type ShellState } from "./store";

/** Subscribe to the whole shell state. Cheap: the state object is replaced on
    every change, so referential equality short-circuits rerenders. */
export function useShell(): ShellState {
  return useSyncExternalStore(subscribe, getState, getState);
}
